import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { Category } from '../../../models/category';
import { CourseCardType } from '../../../enums/courseCardType.enum';
import { SearchBarComponent } from "../../../shared/search-bar/search-bar.component";
import { StoreCardComponent } from '../../../shared/store-card/store-card.component';
import { PipesModule } from '../../../pipes/pipes.module';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { MaterialModule } from '../../../material/material.module';

@Component({
  selector: 'app-courses-section',
  standalone: true,
  imports: [
    SearchBarComponent,
    StoreCardComponent,
    PipesModule,
    NgxSkeletonLoaderModule,
    MaterialModule
  ],
  templateUrl: './courses-section.component.html',
  styleUrl: './courses-section.component.scss'
})
export class CoursesSectionComponent implements OnInit, OnChanges {

  cardTypes = CourseCardType;

  @Input() categories: Category[] = [];

  showSkeleton = true;

  skeletonStyle = {
    'height': '408px',
    'width': '310px',
    'border-radius': '8px',
  };

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['categories'] && !changes['categories'].firstChange) {      
      this.showSkeleton = false;
    }
  }
}
